interface Props {
  /**
   * Hands the lane's outer DOM element back to the stage. Stage uses the
   * element's bounding rect as the flight origin for placement animations
   * in Stage Calm — once any cluster exists the ResponseTicker unmounts, so
   * this lane is the on-screen home of "incoming" responses and the right
   * place for the flight to start.
   */
  registerLaneRef?: (el: HTMLElement | null) => void;
}

/**
 * Stage Calm: the lane has no visible content of its own. Its only job is
 * to host the FlightLayer's stacked chips during their hold phase and to
 * expose its bounding rect to useStageFlightAnimations (via registerLaneRef)
 * as the flight origin. New submissions animate via FlightLayer at the
 * StageView level — there is no in-lane drift animation anymore.
 */
export default function IncomingLane({ registerLaneRef }: Props) {
  return (
    <div
      ref={registerLaneRef}
      className="flex flex-col w-full min-h-0 flex-1 mt-6 border-t border-rc-paper/8 pt-4"
    />
  );
}
